import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '../../../../../lib/utilities';
import { FormattedPrice } from '../../price/formatted_price';
import { RowTwoCells } from './row_two_cells';
import Tooltip from '../../tooltip/tooltip';
import getTranslatedText from '../../../helper/get_translated_text';
import { Label } from './shipping_price/label';

export function SetPriceIsMps({
    name,
    label,
    price,
    currencyIsoCode,
    overrides,
    loading,
    isSub,
    hasBorder,
    hasPaddingBottom,
    labelExtraChildren,
    priceExtraChildren,
}) {
    const labelName = name.split(' ')[0];
    const left = [
        <Tooltip
            label={getTranslatedText('badge-price-special')}
            content={getTranslatedText('pdp-sidebar-price-per-piece-ismps-product-tooltip-content')}
            key='pdp-mps-special-price-tooltip'
            additionalClassNames={['badge-price-special']}
        />,
        <Label name={labelName} label={label} key="Label" />,
        ...labelExtraChildren
    ];

    const right = [
        <FormattedPrice
            price={price}
            currencyIsoCode={currencyIsoCode}
            className={labelName + '__price'}
            loading={loading}
            key="price"
            inCents={true}
            overrides={overrides}
        />,
        ...priceExtraChildren
    ];

    return (
        <RowTwoCells
            name={name}
            isSub={isSub}
            hasBorder={hasBorder}
            hasPaddingBottom={hasPaddingBottom}
            left={left}
            right={right}
        />
    );
}

const extraChildrenPropType = PropTypes.arrayOf(PropTypes.element);

SetPriceIsMps.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]).isRequired,
    price: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    isSub: PropTypes.bool,
    hasBorder: PropTypes.bool,
    hasPaddingBottom: PropTypes.bool,
    labelExtraChildren: extraChildrenPropType,
    priceExtraChildren: extraChildrenPropType,
    overrides: PropTypes.object,
    onLabelClick: PropTypes.func,
};

SetPriceIsMps.defaultProps = {
    loading: false,
    isSub: false,
    hasBorder: true,
    hasPaddingBottom: true,
    labelExtraChildren: [],
    priceExtraChildren: [],
    labelExtraParents: [],
    overrides: {},
    onLabelClick: noop,
};
